export enum LabsFlag {
  ReactBankReconciliation = 'labs-flag:reactBankReconciliation',
  ReactBills = 'labs-flag:reactBills',
  NavigationMyClient = 'labs-flag:navigationMyClient',
  MastercardOpenFinance = 'labs-flag:mastercardOpenFinance',
  Reports = 'labs-flag:reports',
  CashPilotOpenBank = 'labs-flag:cashPilotOpenBank',
  ExpertReportsSuppliersBalance = 'labs-flag:expertReportsSuppliersBalance',
  ExpertReportsCustomersBalance = 'labs-flag:expertReportsCustomersBalance',
  ExpertReportsTrialBalance = 'labs-flag:expertReportsTrialBalance',
  ExpertReportsProfitAndLoss = 'labs-flag:expertReportsProfitAndLoss',
  ExpertReportsBalanceSheet = 'labs-flag:expertReportsBalanceSheet',
  ExpertReportsVatDeclarations = 'labs-flag:expertReportsVatDeclarations',
  ExpertReviewEntries = 'labs-flag:expertReviewEntries',
  ImportedInvoices = 'labs-flag:importedInvoices',
  ImportedInvoiceReview = 'labs-flag:importedInvoiceReview',
  ReconciliationViewAsDefault = 'labs-flag:reconciliationViewAsDefault',
  InvoicingSettings = 'labs-flag:invoicingSettings',
}
